import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import MapView from '../views/MapView.vue'
import VRMask from '../views/VRMask.vue'
import Dubbing from '../views/Dubbing.vue'
import Community from '../views/Community.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'map',
        name: 'MapView',
        component: MapView
      },
      {
        path: 'vr-mask',
        name: 'VRMask',
        component: VRMask
      },
      {
        path: 'dubbing',
        name: 'Dubbing',
        component: Dubbing
      },
      {
        path: 'community',
        name: 'Community',
        component: Community
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
